
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import { Dictionary } from "vue-router/types/router";
import tablePagination from "@/mixins/table-pagination";
import tableFilters from "@/mixins/table-filters";
import { parseArrayParams } from "@/services/helpers";
import { mask } from "vue-the-mask";

import SyncData from "@/modules/clients/components/SyncData.vue";
import DateRangePicker from "@/components/form-components/DateRangePicker.vue";

export default Vue.extend({
  name: "Clients",

  components: { DateRangePicker, SyncData },

  mixins: [tablePagination, tableFilters],

  directives: { mask },

  data: () => ({
    parseArrayParams,
    filter: {} as Dictionary<string | (string | null)[]>,
    headers: [] as Array<any>,
    items: [] as Array<any>,
    loading: false as boolean,
    showMenu: false,
    x: 0,
    y: 0,
    activeItem: null as any,
    activeItemId: null as any,
    selects: {
      types: [] as Array<any>
    },
    userToSync: {} as any,
    syncModal: false as boolean
  }),

  async beforeRouteEnter(to, from, next) {
    try {
      const params = {
        filter: to.query,
        page: {
          number: to.params.page,
          size: 50
        }
      };
      const response = await API.clients().getData(params);
      const types = await API.clients().getClientTypes();

      next(vm => {
        vm.selects.types = types;
        vm.setFilters(params.filter);
        vm.setServerResponse(response);
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async loadData(): Promise<void> {
      this.loading = true;
      try {
        const response = await this.$API.clients().getData({
          filter: this.parseArrayParams(this.filter),
          page: this.pagination,
          sort: this.getSortParams()
        });
        this.setServerResponse(response);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    async deleteRow(id: number): Promise<void> {
      this.loading = true;
      try {
        await this.$API.clients().delete(id);
        await this.$store.dispatch(
          "alert/showSuccess",
          this.$t("global_alert.successful_removal")
        );
        await this.loadData();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    setFilters(filter: Dictionary<string | (string | null)[]>): void {
      const newFilters = this.getAvailableFilters(filter);

      if (newFilters.hasOwnProperty("identity_card_date")) {
        newFilters.identity_card_date = newFilters.identity_card_date.split(
          ","
        );
      }
      if (newFilters.hasOwnProperty("created_at")) {
        newFilters.created_at = newFilters.created_at.split(",");
      }
      if (Object.keys(newFilters).length) {
        this.showFilters = true;
      }

      this.filter = newFilters;
      this.changeActiveFilters();
    },
    setServerResponse({ items, headers }: any) {
      this.headers = [
        ...headers,
        {
          text: "",
          value: "actions",
          width: "100px",
          align: "center",
          sortable: false
        }
      ];

      this.items = items?.data;

      this.totalItems = items.total;
    },
    showContextMenu(e: any, item: any) {
      this.activeItem = item.item;
      this.activeItemId = item.item.id;
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    s2ab(s: any): any {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    async exportClients(): Promise<any> {
      try {
        const response = await this.$API.clients().exportClients();

        const link = document.createElement("a");
        link.href = response.url;
        link.target = "_blank";
        link.download = response.name;
        link.click();
        link.remove();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    syncUser(user: any) {
      this.syncModal = true;
      this.userToSync = user;
    }
  }
});
